import { requiredMessage } from 'validation'
import * as yup from 'yup'

export const EDIT_SALE_SCHEMA = yup.object().shape({
  salePriceEur: yup.number().required(requiredMessage),
  splitType: yup.object().shape({
    value: yup.string().trim().required(requiredMessage),
    name: yup.string().trim().required(requiredMessage),
  }),
})